import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectDestructuringEmpty from '@babel/runtime/helpers/objectDestructuringEmpty';
import _extends from '@babel/runtime/helpers/extends';
import classnames from 'classnames';
import React__default from 'react';
import Header from './Header/index.js';
import { TablePagination } from './Pagination/index.js';
import Rows from './Rows/index.js';
import SelectionCellAll from './RowSelection/SelectionCellAll.js';
import { doColumnFieldWarning, getTableWidth, getDisplayColumns } from './utils/columnUtils.js';
import { useTable } from './utils/hooks.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TableAdvanced = function TableAdvanced(_ref) {
  var otherProps = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTable = useTable(),
    _useTable$state = _useTable.state,
    alternateRowColor = _useTable$state.alternateRowColor,
    cellPadding = _useTable$state.cellPadding,
    className = _useTable$state.className,
    columns = _useTable$state.columns,
    dataTestId = _useTable$state.dataTestId,
    fixedHeader = _useTable$state.fixedHeader,
    groupDisplayType = _useTable$state.groupDisplayType,
    height = _useTable$state.height,
    name = _useTable$state.name,
    pagination = _useTable$state.pagination,
    roundCorner = _useTable$state.roundCorner,
    rowSelection = _useTable$state.rowSelection,
    scrollableWidth = _useTable$state.scrollableWidth,
    showGrid = _useTable$state.showGrid,
    state = _useTable.state;
  doColumnFieldWarning(state);

  //get the column that will act as each row's header for A11y,
  //error if one is not found or if multiples are found
  var tableClasses = classnames('C-TableAdvanced', _defineProperty(_defineProperty({
    '--alternateRowColor': alternateRowColor
  }, "--cell-padding-".concat(cellPadding), cellPadding), '--showGrid', showGrid), className);
  var containerClasses = classnames('C-TableAdvancedContainer', {
    '--overflow-y': height,
    'C-TableAdvanced__selectionCell': !!rowSelection,
    className: className,
    roundCorner: roundCorner,
    scrollableWidth: scrollableWidth
  });
  var headerClasses = classnames('C-TableAdvanced__header', {
    '--fixed': fixedHeader
  });

  // TODO this will be a dupe to rows code
  var classesForColumns = columns.columnDefs.reduce(function (obj, _ref2) {
    var field = _ref2.field,
      align = _ref2.align,
      pinned = _ref2.pinned;
    return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, field, classnames(_defineProperty(_defineProperty({}, "--text-align-".concat(align), align), "--pinned", pinned))));
  }, {});

  // TODO: wrap in helper as above
  var stylesForColumns = columns.columnDefs.reduce(function (prev, _ref3) {
    var _data$defaultColDef;
    var field = _ref3.field,
      width = _ref3.width,
      pinned = _ref3.pinned;
    var computedWidth = width || ((_data$defaultColDef = data.defaultColDef) === null || _data$defaultColDef === void 0 ? void 0 : _data$defaultColDef.width) || 250;
    var newPinOffset = pinned ? prev.pinOffset + computedWidth : prev.pinOffset;
    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty(_defineProperty({}, field, {
      left: pinned ? "".concat(prev.pinOffset, "px") : undefined
    }), "pinOffset", newPinOffset));
  }, {
    pinOffset: rowSelection ? 45 : 0
  });
  var showTopPagination = (pagination === null || pagination === void 0 ? void 0 : pagination.location) === 'top' || (pagination === null || pagination === void 0 ? void 0 : pagination.location) === 'top-bottom';
  var showBottomPagination = (pagination === null || pagination === void 0 ? void 0 : pagination.location) !== 'top';
  var HeaderCells = function HeaderCells() {
    return getDisplayColumns(columns.columnDefs, groupDisplayType).map(function (column) {
      return /*#__PURE__*/React__default.createElement(Header, {
        key: column.field,
        columnData: column,
        classesForColumn: classesForColumns[column.field],
        stylesForColumn: stylesForColumns[column.field]
      });
    });
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showTopPagination && /*#__PURE__*/React__default.createElement(TablePagination, {
    dataTestId: "".concat(dataTestId, "_top")
  }), /*#__PURE__*/React__default.createElement("div", {
    className: containerClasses,
    "data-testid": dataTestId ? "".concat(dataTestId, "_scrollContainer") : null,
    style: {
      maxHeight: "".concat(height, "px")
    },
    tabIndex: "0"
  }, /*#__PURE__*/React__default.createElement("table", _extends({
    "aria-label": name,
    className: tableClasses,
    "data-testid": dataTestId,
    role: "table",
    style: _objectSpread({}, getTableWidth(columns.columnDefs, scrollableWidth, groupDisplayType))
  }, otherProps), /*#__PURE__*/React__default.createElement("thead", {
    className: headerClasses
  }, /*#__PURE__*/React__default.createElement("tr", {
    className: "C-TableAdvanced__headerRow",
    role: "row",
    key: "row-header"
  }, rowSelection !== undefined && /*#__PURE__*/React__default.createElement(SelectionCellAll, {
    tableName: name,
    pinned: columns.columnDefs.some(function (_ref4) {
      var pinned = _ref4.pinned;
      return pinned;
    })
  }), /*#__PURE__*/React__default.createElement(HeaderCells, null))), /*#__PURE__*/React__default.createElement("tbody", {
    className: "C-TableAdvanced__body"
  }, /*#__PURE__*/React__default.createElement(Rows, null)), /*#__PURE__*/React__default.createElement("tfoot", {
    className: "C-TableAdvanced__footer"
  }))), showBottomPagination && /*#__PURE__*/React__default.createElement(TablePagination, {
    dataTestId: "".concat(dataTestId, "_bottom")
  }));
};

export { TableAdvanced, TableAdvanced as default };
